//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/StructureDesign.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[[0,"ActiveCommand",1,0],[0,"ActiveFeature",1,"Features.StructureDesign.IFrame",0]],[[[],"Enter",{},0,0],[[],"Exit",{},0,0],[[],"SetCancelled",{},0,0],[["feature"],"Edit",{},1,0],[["bCreateMember","bUpdateFeature"],"ShowFrameMember",{},2,0],[[],"ResizeFrameDimension",{},0,0],[[],"ClearCachedGeometry",{},0,0],[["builder"],"SetActiveBuilder",{},1,0],[[],"DeleteActiveBuilder",{},0,0],[["frameCurves","bInPreview"],"ConvertFrameCurveToReference",{},2,0],[["frameCurves","bInPreview"],"ConvertFrameCurveFromReference",{},2,0],[["update_scope"],"SetUpdateScope",{},1,0],[[],"UpdateModel",{},0,0]],[["FrameVertexCollection","StructureDesign.FrameVertexCollection",0]]];
SPLM.StructureDesign.Frame3DManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.StructureDesign.Frame3DManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.StructureDesign.Frame3DManager.CommandTypes = Object.freeze({
    "None" : "None", "Frame3D" : "Frame3D", "Line" : "Line", "Rectangle" : "Rectangle", "Box" : "Box", "Plane" : "Plane", "StructureBasic" : "StructureBasic", "StructureSupport" : "StructureSupport", "StructureLevels" : "StructureLevels", "Member" : "Member", "Fillet" : "Fillet"});

SPLM.StructureDesign.Frame3DManager.UpdateLevel = Object.freeze({
    "Frame3dOnly" : "Frame3dOnly", "FullModel" : "FullModel"});

export default SPLM;